export default __webpack_public_path__ + "static/media/Calendar30DaysIcon.02f7933f.svg";